import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2483d8d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "textarea-container border-token-border-default flex w-full cursor-text flex-col items-center justify-center rounded-[28px] border bg-clip-padding contain-inline-size overflow-clip shadow-sm sm:shadow-lg dark:shadow-none! bg-token-main-surface-primary dark:bg-[#303030]" }
const _hoisted_2 = ["contenteditable", "onKeydown", "placeholder"]
const _hoisted_3 = {
  key: 1,
  class: "ai-writing"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "DansukAI size yanıt yazıyor... Tamamlandığında tüm yanıtı göreceksiniz.", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "send-button-container" }
const _hoisted_8 = {
  key: 2,
  class: "project-members-container"
}
const _hoisted_9 = ["onClick"]

import { ref, computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'chatTextarea',
  props: ["isAIWriting", "projectMembers"],
  emits: ['messagePosted'],
  setup(__props, { emit: __emit }) {


const props = __props
const emits = __emit
const hasTaggedMember = ref(false)
const newMessage = ref('')
const aiTextArea = ref(null)

const isPostingMessage = ref(false)

const placeholderText = computed(() => {
    if (props.projectMembers && props.projectMembers.length > 0) {
        return 'Mesajınıza "@" ile başlayarak proje üyelerini etiketleyebilirsiniz.';
    }
    return 'Mesajınızı buraya yazın...';
})

const filteredMembers = computed(() => {
    if (!newMessage.value.startsWith('@') || hasTaggedMember.value) return [];
    
    const searchText = newMessage.value.substring(1).toLowerCase();
    if (!searchText) return props.projectMembers || [];
    
    return (props.projectMembers || []).filter(member => 
        member.name.toLowerCase().startsWith(searchText)
    );
})

const onInput = (event) => {
    newMessage.value = event.target.innerText;
    // Reset hasTaggedMember if the message doesn't start with @
    if (!newMessage.value.startsWith('@')) {
        hasTaggedMember.value = false;
    }
}

const tagMember = (memberName: string) => {
    // Add the tagged member at the start of the message
    const newMessageContent = `@${memberName}`;
    newMessage.value = newMessageContent;
    
    // Update the contenteditable div
    if (aiTextArea.value) {
        aiTextArea.value.innerText = newMessageContent;
        
        // Move cursor to the end
        const range = document.createRange();
        const sel = window.getSelection();
        range.selectNodeContents(aiTextArea.value);
        range.collapse(false);
        sel?.removeAllRanges();
        sel?.addRange(range);
    }
    
    hasTaggedMember.value = true;
}

const postMessage = () => {
    emits('messagePosted', newMessage.value);
    newMessage.value = '';
    hasTaggedMember.value = false;
    if (aiTextArea.value) {
        aiTextArea.value.innerText = '';
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!props.isAIWriting)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "aiTextArea",
          ref: aiTextArea,
          class: "ai-textarea",
          contenteditable:  !isPostingMessage.value,
          onInput: onInput,
          onKeydown: _withKeys(_withModifiers(postMessage, ["prevent"]), ["enter"]),
          placeholder: placeholderText.value
        }, null, 40, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6)),
    _createElementVNode("div", _hoisted_7, [
      (!props.isAIWriting)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "send-button",
            onClick: postMessage
          }, "↑"))
        : _createCommentVNode("", true)
    ]),
    (filteredMembers.value.length > 0 && !hasTaggedMember.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMembers.value, (member) => {
              return (_openBlock(), _createElementBlock("li", {
                onClick: ($event: any) => (tagMember(member.name)),
                key: member.id
              }, _toDisplayString(member.name), 9, _hoisted_9))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})